const menu = document.querySelector(".menu");
const menuMain = menu.querySelector(".menu-main");
const goBack = menu.querySelector(".go-back");
const menuTrigger = document.querySelector(".mobile-menu-trigger");
const menuToggle = document.querySelector("#menuToggle");
const closeMenu = menu.querySelector(".mobile-menu-close");
const overlay = document.querySelector(".menu-overlay");

let subMenu;
let currentMenuLevel = 0;
let currentSubMenu = [];

menuMain.addEventListener("click", (e) => {
    if (!menu.classList.contains("active")) return;

    const hasChildren = e.target.closest(".menu-item-has-children");

    // Vérifie si le clic est sur l'icône flèche
    if (e.target.classList.contains("fa-angle-down") && hasChildren) {
        e.preventDefault(); // Empêche la redirection
        showSubMenu(hasChildren);
    }
});

goBack.addEventListener("click", () => {
    hideSubMenu();
});

if (menuTrigger) {
    menuTrigger.addEventListener("click", () => {
        toggleMenu();
    });
}

if (menuToggle) {
    const checkbox = menuToggle.querySelector('input[type="checkbox"]');
    if (checkbox) {
        checkbox.addEventListener("change", () => {
            // Le CSS gère déjà l'affichage du menu via input:checked ~ ul
            // Mais on peut ajouter la classe active pour le JS
            if (checkbox.checked) {
                menu.classList.add("active");
                overlay.classList.add("active");
            } else {
                menu.classList.remove("active");
                overlay.classList.remove("active");
            }
        });
    }
}

closeMenu.addEventListener("click", () => {
    toggleMenu();
});

overlay.addEventListener("click", () => {
    toggleMenu();
});

function toggleMenu() {
    menu.classList.toggle("active");
    overlay.classList.toggle("active");

    // Si on utilise le #menuToggle, on doit aussi décocher la checkbox
    if (menuToggle) {
        const checkbox = menuToggle.querySelector('input[type="checkbox"]');
        if (checkbox) {
            checkbox.checked = menu.classList.contains("active");
        }
    }
}

function showSubMenu(hasChildren) {
    subMenu = hasChildren.querySelector(".sub-menu");
    subMenu.classList.add("active");
    subMenu.style.animation = "slideLeft 0.5s ease forwards";
    
    const menuTitle = hasChildren.querySelector("a").textContent.trim();
    menu.querySelector(".current-menu-title").innerHTML = menuTitle;

    menu.querySelector(".mobile-menu-head").classList.add("active");
    
    currentMenuLevel++;
    currentSubMenu.push(subMenu);

    goBack.style.display = "block";
}

function hideSubMenu() {
    if (currentMenuLevel > 1) {
        const lastSubMenu = currentSubMenu.pop();
        lastSubMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
            lastSubMenu.classList.remove("active");
        }, 300);

        const previousSubMenu = currentSubMenu[currentSubMenu.length - 1];
        const previousTitle = previousSubMenu ? previousSubMenu.parentNode.querySelector("a").textContent.trim() : "";
        menu.querySelector(".current-menu-title").innerHTML = previousTitle;
    } else {
        subMenu.style.animation = "slideRight 0.5s ease forwards";
        setTimeout(() => {
            subMenu.classList.remove("active");
        }, 300);
        menu.querySelector(".current-menu-title").innerHTML = "";
    }

    currentMenuLevel--;

    if (currentMenuLevel === 0) {
        goBack.style.display = "none";
    }
    
    menu.querySelector(".mobile-menu-head").classList.toggle("active", currentMenuLevel > 0);
}

window.onresize = function () {
    if (this.innerWidth > 991) {
        if (menu.classList.contains("active")) {
            toggleMenu();
        }
    }
};


if (document.querySelectorAll('#offcanvasScrolling').length > 0) {

    var OffcanvasFilter = document.getElementById('offcanvasScrolling')
    OffcanvasFilter.addEventListener('show.bs.offcanvas', function () {
        window.scrollTo(0, 0);

    })
}

//mega menu

const level1LiMega = document.querySelectorAll('.level1Li-mega');
const level1ChevronClick = document.querySelectorAll('.level1ChevronClick');
const level2LiMega = document.querySelectorAll('.level2Li-mega');
const level3LiMega = document.querySelectorAll('.level3Li-mega');

// Hide level two and level three by default
level2LiMega.forEach(item => {
    item.style.display = 'none';

    item.addEventListener('click', e => {
        level2LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            item.style.color = '#33424B'

        });
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const id = item.getAttribute('data-id-level');
        level3LiMega.forEach(element => {
            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionTwo = element.getAttribute('data-sectionTwo');
                // console.log(sectionTwo)
                const titleLvlThree = document.querySelector('#titleLvlThree');
                titleLvlThree.textContent = sectionTwo;
            } else {
                element.style.display = 'none';

            }
        });
    });

});

level3LiMega.forEach(item => {
    item.style.display = 'none';
});

level1LiMega.forEach(item => {
    //accesibility
    const navElements = document.querySelectorAll('.level1ChevronClick');

    item.addEventListener('keydown', e => {

        if (navElements && e.keyCode === 13) {
            // console.log("click")
            navElements.forEach(NavElement => {
                NavElement.tabIndex = -1;

            })
        }

        level1LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            const titleLvlThree = document.querySelector('#titleLvlThree');
            titleLvlThree.textContent = ''
            // const loopIndex = item.getAttribute('data-loopIndex');


        });
        const id = item.getAttribute('data-id');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const noLink = item.getAttribute('data-nolink');

        const sectionOneLink = item.getAttribute('data-link');


        level2LiMega.forEach(element => {

            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionOne = element.getAttribute('data-section');
                const titleLvlTwo = document.querySelector('#titleLvlTwo');
                const linkLvlTwo = document.querySelector('#linkLvlTwo');
                // console.log('link :' + sectionOneLink)
                titleLvlTwo.textContent = sectionOne;
                linkLvlTwo.title = sectionOne;

                if (sectionOneLink) {
                    linkLvlTwo.href = sectionOneLink;
                    // console.log(sectionOneLink)

                } else {
                    linkLvlTwo.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';
            }
        });
        level3LiMega.forEach(item => {
            item.style.display = 'none';
        });

    })

    item.addEventListener('click', e => {


        level1LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            const titleLvlThree = document.querySelector('#titleLvlThree');
            titleLvlThree.textContent = ''
            // const loopIndex = item.getAttribute('data-loopIndex');


        });
        const id = item.getAttribute('data-id');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const noLink = item.getAttribute('data-nolink');

        const sectionOneLink = item.getAttribute('data-link');


        level2LiMega.forEach(element => {

            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionOne = element.getAttribute('data-section');
                const titleLvlTwo = document.querySelector('#titleLvlTwo');
                const linkLvlTwo = document.querySelector('#linkLvlTwo');
                // console.log('link :' + sectionOneLink)
                titleLvlTwo.textContent = sectionOne;
                linkLvlTwo.title = sectionOne;

                if (sectionOneLink) {
                    linkLvlTwo.href = sectionOneLink;
                    // console.log(sectionOneLink)

                } else {
                    linkLvlTwo.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';
            }
        });
        level3LiMega.forEach(item => {
            item.style.display = 'none';
        });
    });

})
;

level2LiMega.forEach(item => {
    item.style.display = 'none';

    item.addEventListener('click', e => {
        level2LiMega.forEach(item => {
            item.classList.remove("active");
            item.style.fontWeight = '400'
            item.style.color = '#33424B'

        });
        const sectionTwoLink = item.getAttribute('data-link');
        item.style.fontWeight = '500'
        item.style.color = '#008CD7'
        item.classList.add("active");
        const id = item.getAttribute('data-id-level');
        level3LiMega.forEach(element => {
            if (element.getAttribute('data-id') === id) {
                element.style.display = 'flex';
                const sectionTwo = element.getAttribute('data-sectionTwo');
                const titleLvlThree = document.querySelector('#titleLvlThree');
                titleLvlThree.textContent = sectionTwo;
                const linkLvlThree = document.querySelector('#linkLvlThree');
                linkLvlThree.href = sectionTwoLink;
                linkLvlThree.title = sectionTwo;

                if (sectionTwoLink) {
                    linkLvlThree.href = sectionTwoLink;

                } else {
                    linkLvlThree.href = "javascript:void(0)";
                }
            } else {
                element.style.display = 'none';

            }
        });
    });

});

level3LiMega.forEach(item => {
    item.style.display = 'none';
});

// ---------------------------------------------------------------------------
// Hover-intent for desktop mega menu (fixes "triangle of death" problem)
// ---------------------------------------------------------------------------
(function () {
  const DELAY_IN = 250;
  const DELAY_OUT = 200;
  const DESKTOP_BP = 1200;

  let enterTimer = null;
  let leaveTimer = null;
  let currentActive = null;
  let listeners = [];

  function activate(item) {
    if (currentActive && currentActive !== item) {
      currentActive.classList.remove('hover-active');
    }
    item.classList.add('hover-active');
    currentActive = item;
  }

  function deactivate(item) {
    item.classList.remove('hover-active');
    if (currentActive === item) currentActive = null;
  }

  function clearTimers() {
    clearTimeout(enterTimer);
    clearTimeout(leaveTimer);
  }

  // Returns true when the mouse cursor is in the right half (blue panel zone)
  // of the sub-menu. Level-2 items span the full width, so mouseenter fires
  // even when the user is visually inside the level-3 panel.
  function isInBluePanelZone(e, item) {
    var submenu = item.closest('.sub-menu');
    if (!submenu) return false;
    var rect = submenu.getBoundingClientRect();
    return e.clientX > rect.left + rect.width / 2;
  }

  function cleanup() {
    clearTimers();
    listeners.forEach(function (obj) {
      obj.el.removeEventListener(obj.evt, obj.fn);
    });
    listeners = [];
    if (currentActive) {
      currentActive.classList.remove('hover-active');
      currentActive = null;
    }
    var mm = document.querySelector('.menu-main');
    if (mm) mm.classList.remove('js-hover-intent');
  }

  function init() {
    cleanup();
    if (window.innerWidth < DESKTOP_BP) return;

    var mm = document.querySelector('.menu-main');
    if (!mm) return;
    mm.classList.add('js-hover-intent');

    var items = mm.querySelectorAll('.menu-level-2');
    items.forEach(function (item) {
      var level3 = item.querySelector('.menu-level-3');
      if (!level3) return;

      function onItemEnter(e) {
        clearTimers();
        // Ignore phantom hovers when the mouse is in the blue panel zone
        if (currentActive && currentActive !== item && isInBluePanelZone(e, item)) return;
        if (!currentActive) {
          activate(item);
        } else if (currentActive !== item) {
          enterTimer = setTimeout(function () { activate(item); }, DELAY_IN);
        }
      }

      function onItemLeave() {
        clearTimers();
        leaveTimer = setTimeout(function () { deactivate(item); }, DELAY_OUT);
      }

      function onLevel3Enter() {
        clearTimers();
      }

      function onLevel3Leave() {
        clearTimers();
        leaveTimer = setTimeout(function () { deactivate(item); }, DELAY_OUT);
      }

      item.addEventListener('mouseenter', onItemEnter);
      item.addEventListener('mouseleave', onItemLeave);
      level3.addEventListener('mouseenter', onLevel3Enter);
      level3.addEventListener('mouseleave', onLevel3Leave);

      listeners.push({ el: item, evt: 'mouseenter', fn: onItemEnter });
      listeners.push({ el: item, evt: 'mouseleave', fn: onItemLeave });
      listeners.push({ el: level3, evt: 'mouseenter', fn: onLevel3Enter });
      listeners.push({ el: level3, evt: 'mouseleave', fn: onLevel3Leave });
    });

    // Reset when mouse leaves the entire sub-menu
    var subMenus = mm.querySelectorAll('.sub-menu');
    subMenus.forEach(function (sm) {
      function onSubMenuLeave() {
        clearTimers();
        if (currentActive) {
          currentActive.classList.remove('hover-active');
          currentActive = null;
        }
      }
      sm.addEventListener('mouseleave', onSubMenuLeave);
      listeners.push({ el: sm, evt: 'mouseleave', fn: onSubMenuLeave });
    });
  }

  // Debounced resize handler
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(init, 150);
  });

  init();
})();